import { Component } from '@theme/component';
import { debounce, isClickedOutside, onAnimationEnd } from '@theme/utilities';

/**
 * A custom element that manages a dialog.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog – The dialog element.
 *
 * @extends Component<Refs>
 */
export class DialogComponent extends Component {
  requiredRefs = ['dialog'];

  connectedCallback() {
    super.connectedCallback();

    if (this.minWidth || this.maxWidth) {
      window.addEventListener('resize', this.#handleResize);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.minWidth || this.maxWidth) {
      window.removeEventListener('resize', this.#handleResize);
    }
  }

  #handleResize = debounce(() => {
    const { minWidth, maxWidth } = this;

    if (!minWidth && !maxWidth) return;

    const windowWidth = window.innerWidth;
    if (windowWidth < minWidth || windowWidth > maxWidth) {
      this.closeDialog();
    }
  }, 50);

  /**
   * Shows the dialog.
   */
  showDialog() {
    const { dialog } = this.refs;

    if (dialog.open) return;

    document.body.style.width = '100%';
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;

    dialog.showModal();
    this.dispatchEvent(new DialogOpenEvent());

    // Wait until the next tick to add the event listeners to avoid race condition
    // when `showDialog` is called within a click event listener.
    setTimeout(() => {
      this.addEventListener('click', this.#handleClick);
      this.addEventListener('keydown', this.#handleKeyDown);
    });
  }

  /**
   * Closes the dialog.
   */
  closeDialog = async () => {
    const { dialog } = this.refs;

    if (!dialog.open) return;

    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('keydown', this.#handleKeyDown);

    dialog.classList.add('dialog-closing');

    await onAnimationEnd(dialog, undefined, {
      subtree: false,
    });

    document.body.style.width = '';
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo({ top: parseInt(scrollY) * -1, behavior: 'instant' });

    dialog.close();
    dialog.classList.remove('dialog-closing');

    this.dispatchEvent(new DialogCloseEvent());
  };

  /**
   * Toggles the dialog.
   */
  toggleDialog = () => {
    if (this.refs.dialog.open) {
      this.closeDialog();
    } else {
      this.showDialog();
    }
  };

  /**
   * Closes the dialog when the user clicks outside of it.
   *
   * @param {MouseEvent} event - The mouse event.
   */
  #handleClick(event) {
    const { dialog } = this.refs;

    if (isClickedOutside(event, dialog)) {
      this.closeDialog();
    }
  }

  /**
   * Closes the dialog when the user presses the escape key.
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown(event) {
    if (event.key !== 'Escape') return;

    event.preventDefault();
    this.closeDialog();
  }

  /**
   * Gets the minimum width of the dialog.
   *
   * @returns {number} The minimum width of the dialog.
   */
  get minWidth() {
    return Number(this.getAttribute('dialog-active-min-width'));
  }

  /**
   * Gets the maximum width of the dialog.
   *
   * @returns {number} The maximum width of the dialog.
   */
  get maxWidth() {
    return Number(this.getAttribute('dialog-active-max-width'));
  }
}

if (!customElements.get('dialog-component')) customElements.define('dialog-component', DialogComponent);

export class DialogOpenEvent extends CustomEvent {
  constructor() {
    super(DialogOpenEvent.eventName);
  }

  static eventName = 'dialog:open';
}

export class DialogCloseEvent extends CustomEvent {
  constructor() {
    super(DialogCloseEvent.eventName);
  }

  static eventName = 'dialog:close';
}

document.addEventListener(
  'toggle',
  (event) => {
    if (event.target instanceof HTMLDialogElement || event.target instanceof HTMLDetailsElement) {
      if (event.target.hasAttribute('scroll-lock')) {
        const { open } = event.target;

        if (open) {
          document.documentElement.setAttribute('scroll-lock', '');
        } else {
          document.documentElement.removeAttribute('scroll-lock');
        }
      }
    }
  },
  { capture: true }
);


/* ------------------------------------------------ For Stock Avaibility Custom --------------------------------*/
document.addEventListener("DOMContentLoaded", function () { 
const initiallySelected = document.querySelector(
    ".variant-option__button-label input:checked"
  );

  if (initiallySelected) {
    const firstVariantId = initiallySelected.dataset.variantId;
    updateStockDisplay(firstVariantId);
  }

  // When variant changes
  const variantInputs = document.querySelectorAll(
  " .variant-option__button-label input"
);

variantInputs.forEach(input => {
  input.addEventListener("change", () => {
    const selectedVariantId = input.getAttribute("data-variant-id");
    updateStockDisplay(selectedVariantId);
  });
});

  function updateStockDisplay(variantId) {
    const variantStockElement = document.querySelector(
      `.variant-stock-item[data-variant-id='${variantId}']`
    );

    const stockBox = document.getElementById("variant-stock-message");

    if (!variantStockElement || !stockBox) return;

    const quantity = parseInt(variantStockElement.dataset.stock);
    const available = variantStockElement.dataset.available === "true";

    if (!available || quantity <= 0) {
  stockBox.innerHTML = `
  <div class="pulse-circle stock-red"></div>
  <span style="color:#dc2626;">Out of stock</span>
`;
} 
else if (quantity >= 6) {
  stockBox.innerHTML = `
  <div class="pulse-circle stock-green"></div>
  <span style="color:#16a34a;">${quantity} In stock</span>
`;
} 
else if (quantity <= 3) {
  stockBox.innerHTML = `
  <div class="pulse-circle stock-red"></div>
  <span style="color:#dc2626;">Hurry up! Low in stock (${quantity} left)</span>
`;
} 
else if (quantity < 6) {
  stockBox.innerHTML = `
  <div class="pulse-circle stock-orange"></div>
  <span style="color:#f59e0b;">Only ${quantity} left!</span>
`;
}
  }
});


/* *************************************** For Bundle Offer ************************  */

const bundleOffer = document.querySelector(".bundle-offer-box");

const radios = document.querySelectorAll('input[name="bundle_choice"]');
const variantLabels = document.querySelectorAll(".variant-option__button-label");

document.addEventListener("DOMContentLoaded", function () { 
if(bundleOffer){
  on_variant_dom_reload();
bundle_variant();

radios.forEach(radio => {
  radio.addEventListener("change", () => {
    const bundleVariantIds = JSON.parse(radio.dataset.variantIds);
    // Track the first visible element
    let firstVisibleInput = null;

    variantLabels.forEach(label => {
      const input = label.querySelector("input[data-variant-id]");
      const variantId = Number(input?.dataset.variantId);
      
      if (bundleVariantIds.includes(variantId)) {
        label.style.display = "";
        if (!firstVisibleInput) firstVisibleInput = input; // store first available variant
      } else {
        label.style.display = "none";
      }
    });

    // Auto-select first visible variant
    if (firstVisibleInput) {
      firstVisibleInput.checked = true;
      firstVisibleInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
});
}
});

function bundle_variant(){

  const radio = document.querySelector('input[name="bundle_choice"]:checked');
const variantLabels = document.querySelectorAll(".variant-option__button-label");


      const bundleVariantIds = JSON.parse(radio.dataset.variantIds);

      // Track the first visible element
      let firstVisibleInput = null;

      variantLabels.forEach(label => {
        const input = label.querySelector("input[data-variant-id]");
        const variantId = Number(input?.dataset.variantId);

        if (bundleVariantIds.includes(variantId)) {
          label.style.display = "";
        } else {
          label.style.display = "none";
        }
      });

      
}

function on_variant_dom_reload() {
  const params = new URLSearchParams(window.location.search);

  const variant_search = params.get('variant');   

  radios.forEach(radio => {
    const ids = JSON.parse(radio.dataset.variantIds);
    console.log(variant_search);
    if (ids.includes(Number(variant_search))) {
  radio.checked = true;
}

  });
}


if (window.location.pathname.includes("/products/")) {
  const menuItem = document.querySelectorAll(".menu-list__link")[2];
  const drawerItem = document.querySelectorAll(".menu-drawer__menu li")[2];

  if (menuItem) {
    menuItem.classList.add("menu-list__link--active");
  }

  if (drawerItem) {
    drawerItem.classList.add("active");
  }
}

/* ------------------------------------------------------ Variant Functionalities For Product Bundle Offer ------------------------------------- */


const bundleRadios = document.querySelectorAll(
  '.product-bundle_wrapper input[type="radio"]'
);
const bundleContainer = document.querySelector(".product-bundle-offer-box")
const variantGrid = document.querySelector(".variant-grid");
const variantLabel = document.querySelectorAll(".variant-option > label");
const quantitySelector = document.querySelector(".quantity-selector");
const bundleReminder = document.querySelector(".product-bundle-options .reminder")
function applyBundleStyles() {
  if(bundleContainer){
    variantGrid.style.display = "flex";
  bundleReminder.style.display = "inline-block";
  variantLabel.forEach(label => {
    label.classList.add("product-bundle-applied");
  });

  quantitySelector.classList.add("quantity-bundle-applied");
  }
  
}

function removeBundleStyles() {
  if(variantGrid){
    variantGrid.style.display = "none";
  }
  if(bundleReminder){
    bundleReminder.style.display = "none";
  }
  

  if(variantLabel){
    variantLabel.forEach(label => {
    label.classList.remove("product-bundle-applied");
  });
  }
  if(quantitySelector){
    quantitySelector.classList.remove("quantity-bundle-applied");
  }

  
}

// Central function to check which bundle is selected
function updateBundleStyles() {
  
  const twoPackSelected = Array.from(bundleRadios).some(
    radio => radio.checked && radio.classList.contains("product-pack-two")
  );
  console.log(twoPackSelected);
  if (twoPackSelected) {
    applyBundleStyles();
  } else {
    removeBundleStyles();
  }
}


// Run on page load
window.addEventListener("pageshow", (event) => {

    updateBundleStyles();
  
    
  
});

// Run on radio change
bundleRadios.forEach(radio => {
  radio.addEventListener("change", updateBundleStyles);
});





function waitForElement(selector) {
  return new Promise(resolve => {
    const element = document.querySelector(selector);
    if (element) return resolve(element);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

let selectedVariants = [];

function initBundleButton() {
  waitForElement(
    "button.shopify-payment-button__button, a.shopify-payment-button__more-options"
  ).then(oldBuyBtn => {
    // Prevent double-initialization
    if (oldBuyBtn.dataset.bundleInit) return;
    oldBuyBtn.dataset.bundleInit = "true";

    const radios = document.querySelectorAll(
      '.product-bundle_wrapper input[type="radio"]'
    );

    if (!radios.length) return;

    // Clone buy button
    const newBuyBtn = oldBuyBtn.cloneNode(true);
    newBuyBtn.style.display = "none";
    oldBuyBtn.after(newBuyBtn);

    newBuyBtn.addEventListener("click", e => {
  e.preventDefault();

  if (!selectedVariants.length) {
    console.log("No elements selected");
    return;
  }


  const cartItems =
    selectedVariants.length === 1
      ? `${selectedVariants[0].value}:2`
      : selectedVariants
          .slice(0, 2)
          .map(v => `${v.value}:1`)
          .join(",");

  // Redirect with fresh cart
  window.location.href = `/cart/${cartItems}`;
});

    function updateButtonVisibility() {
      const [first, second] = radios;

      if (first?.checked) {
        oldBuyBtn.style.display = "";
        newBuyBtn.style.display = "none";
      } else if (second?.checked) {
        oldBuyBtn.style.display = "none";
        newBuyBtn.style.display = "";
      }
    }

    radios.forEach(radio =>
      radio.addEventListener("change", updateButtonVisibility)
    );

    updateButtonVisibility();
  });
}

// Run on normal load + bfcache restore
window.addEventListener("pageshow", initBundleButton);


function initVariantSelection(event) {
  const elementsBundle = document.querySelectorAll(
    ".variant-grid .variant-tile input"
  );

  if (!elementsBundle.length) return;

  // If restored from bfcache, remove old listeners safely
  if (event?.persisted) {
    elementsBundle.forEach(cb => {
      const clone = cb.cloneNode(true);
      cb.replaceWith(clone);
    });
  }

  const freshElements = document.querySelectorAll(
    ".variant-grid .variant-tile input"
  );

  // Restore selectedVariants from checked inputs
  selectedVariants = [...freshElements].filter(el => el.checked);

  freshElements.forEach(cb => {
    cb.addEventListener("change", () => {
      selectedVariants = [...freshElements].filter(el => el.checked);
    });
  });
}

// Normal load
document.addEventListener("DOMContentLoaded", initVariantSelection);

// Back / forward cache restore
window.addEventListener("pageshow", initVariantSelection);



window.addEventListener("pageshow",() =>{
  setDisabled(false);
})


    





  function setDisabled(disabled) {
const proudctBundleBox = document.querySelector(".product-bundle-offer-box")
  const RADIOS_SELECTOR =
    '.product-bundle-options > label';
    // Disable radio inputs
    if(proudctBundleBox){
      if(!disabled){
      proudctBundleBox.classList.remove("disabled");
      document.querySelectorAll(RADIOS_SELECTOR).forEach(el => {
      el.classList.remove("disable");
      
    });
    }else{
      proudctBundleBox.classList.add("disabled");
      document.querySelectorAll(RADIOS_SELECTOR).forEach(el => {
      el.classList.add("disable");
      
    });
    }
    
    
    
    
    }
    
    
  }

 